// import { useEffect, useState } from "react";

import SectionStyleOne from "../Helpers/SectionStyleOne";
import SectionStyleTwo from "../Helpers/SectionStyleTwo";
import ViewMoreTitle from "../Helpers/ViewMoreTitle";
// import Ads from "./Ads";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../store/actions";
import Banner from "../HomeThree/Banner";
import LayoutHomeTwo from "../Partials/LayoutHomeTwo";
import BrandSection from "./BrandSection";

import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../utils/response";

export default function Home() {
	const dispatch = useDispatch();

	const [newArrivals, setNewArrivals] = useState([]);
	const [topProducts, setTopProducts] = useState([]);
	const [popularSales, setPopularSales] = useState([]);

	dispatch(hideLoader());

	useEffect(() => {
		dispatch(showLoader());
		axios.get(`${BASE_URL}/home`).then((response) => {
			let new_arrivals = response.data.data.new_arrivals.map((item) => {
				return {
					product_slug: item.slug,
					slug: item.slug,
					id: item.slug,
					image: item.ImgURL + item.thumbnail,
					title: item.label,
					price: item.price,
					review: item.rating ? item.rating : 5,
				};
			});
			setNewArrivals(new_arrivals);
			let top_products = response.data.data.top_products.map((item) => {
				return {
					product_slug: item.slug,
					slug: item.slug,
					id: item.slug,
					image: item.ImgURL + item.thumbnail,
					title: item.label,
					price: item.variants.find(f=> f.is_default === 1)?.price || item.variants[0]?.price,
					review: item.rating ? item.rating : 5,
				};
			});
			setTopProducts(top_products);
			let popular_sales = response.data.data.popular_sales.map((item) => {
				return {
					product_slug: item.slug,
					slug: item.slug,
					id: item.slug,
					image: item.ImgURL + item.thumbnail,
					title: item.label,
					price: item.price,
					review: item.rating ? item.rating : 5,
				};
			});
			setPopularSales(popular_sales);
			//dispatch(hideLoader());
		});
	}, []);
	console.log('topProducts',topProducts);
	

	return (
		<>
			<LayoutHomeTwo>
				{/* {ads && <Ads handler={adsHandle} />} */}

				<Banner className="banner-wrapper mb-[60px]" />

				<SectionStyleOne
					products={topProducts.slice(2, topProducts.length)}
					categoryTitle=""
					sectionTitle="Top Selling Products"
					seeMoreUrl="/all-products"
					className="category-products mb-[60px]"
				/>

				<ViewMoreTitle
					className="top-selling-product mb-[60px]"
					seeMoreUrl="/all-products"
					categoryTitle="Popular Sales"
				>
					<SectionStyleTwo products={popularSales.slice(0, 4)} />
				</ViewMoreTitle>

				<ViewMoreTitle
					className="top-selling-product mb-[60px]"
					seeMoreUrl="/all-products"
					categoryTitle="New Arrivals"
				>
					<SectionStyleTwo products={newArrivals.slice(0, 4)} />
				</ViewMoreTitle>

				<BrandSection
					sectionTitle="Shop by Brand"
					className="brand-section-wrapper mb-[60px]"
				/>
			</LayoutHomeTwo>
		</>
	);
}
